import {
  formatEther,
  formatUnits,
  parseEther,
  parseUnits,
  readContract,
  writeContractAndWait,
} from "../viem";
import MafiaGameBankAbi from "../../abis/MafiaGameBank.json";
import config from "../../config/config";

const address = config.gamebankAddress;
const abi = MafiaGameBankAbi;

export const getMafiaGameBankBalanceWithSig = async (
  userAddress: string,
  signMsg: string,
  signature: string
) => {
  const balance = await readContract<string>({
    address,
    abi,
    functionName: "balanceOfWithSignMsg",
    args: [userAddress, JSON.stringify(signMsg), signature],
  });

  const decimal = await readContract<string>({
    address,
    abi,
    functionName: "decimals",
  });
  return formatUnits(balance, decimal);
};

export const approveGameCash = async (
  amount: number | string,
  to: string,
  account: string
) => {
  const decimals = Number(
    await readContract<string>({
      address,
      abi,
      functionName: "decimals",
    })
  );
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "approveInGameCurrency",
    args: [to, parseUnits(String(amount), decimals)],
    account,
  });

  return data;
};

export const getTotalSupply = async () => {
  const decimals = Number(
    await readContract<string>({
      address,
      abi,
      functionName: "decimals",
    })
  );
  const data = await readContract<string>({
    address,
    abi,
    functionName: "getTotalSupply",
  });
  return Number(formatUnits(data, decimals));
};

export const getGameBankAllowance = async (from: string, to: string) => {
  const decimals = Number(
    await readContract<string>({
      address,
      abi,
      functionName: "decimals",
    })
  );
  const data = await readContract<string>({
    address,
    abi,
    functionName: "allowances",
    args: [from, to],
  });
  return Number(formatUnits(data, decimals));
};

export const transferGameCash = async (
  account: string,
  amount: number,
  receipient: string,
  signMsg: string,
  signature: string
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "userTransfer",
    args: [
      receipient,
      parseEther(amount.toString()),
      JSON.stringify(signMsg),
      signature,
    ],
    account,
  });
  return data;
};

export const getLastTransferTime = async (userAddress: string) => {
  const data = await readContract<string>({
    address,
    abi,
    functionName: "lastTransferTime",
    args: [userAddress],
  });
  return Number(data);
};

export const claimBankProfit = async (userAddress: string, cityId: number) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "claimProfit",
    args: [cityId],
    account: userAddress,
  });
  return data;
};

export const getCityCashProfit = async (cityId: number) => {
  const data = await readContract<string>({
    address,
    abi,
    functionName: "cityCashProfit",
    args: [cityId],
  });
  return formatEther(data);
};

export const getCityOwnerFee = async (cityId: number) => {
  const data = await readContract<string>({
    address,
    abi,
    functionName: "cityOwnerFee",
    args: [cityId],
  });
  return Number(data);
};

export const setCityOwnerFee = async (
  userAddress: string,
  cityId: number,
  cityOwnerFee: number
) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "setCityOwnerFee",
    args: [cityId, cityOwnerFee],
    account: userAddress,
  });
  return data;
};
